import { render } from "./OurPartners.vue?vue&type=template&id=01916f6f&scoped=true"
import script from "./OurPartners.vue?vue&type=script&lang=js"
export * from "./OurPartners.vue?vue&type=script&lang=js"

import "./OurPartners.vue?vue&type=style&index=0&id=01916f6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01916f6f"]])

export default __exports__